<template>
    <div class="page-homes">
        <CBNavbar @navbar-click="onNavbarClick" />
        <div class="pages">
            <div class="pageContentOne">
                <div class="pageContentOne1">{{ $t('value104') }}</div>
                <div class="pageContentOne2">{{ $t('value105') }}：$0.1</div>
            </div>
            <img src="@/assets/images/background30.png" alt="background30" class="background30">
            <div class="TokenStaking1">{{ $t('value106') }}</div> 
            <div class="TokenStaking2">1.{{ $t('value107') }}</div>
            <div class="TokenStaking2">2.{{ $t('value108') }}</div>
            <div class="TokenStaking2">3.{{ $t('value109') }}</div>
            <div class="TokenStaking2">4.{{ $t('value110') }}</div>
            <div class="TokenStaking3">5.{{ $t('value111') }}</div>
            <div class="underline"></div>
            <div v-if="!judge">
                <div class="TokenStaking4">
                    <div class="TokenStaking4_QuantityOfPledge">{{ $t('value91') }}</div>
                    <div class="TokenStaking4_RevenueInformation" @click="judge=true">
                        <div class="TokenStaking4_RevenueInformation1">{{ $t('value112') }}</div>
                        <img src="@/assets/images/EntryArrow1.png" alt="EntryArrow1" class="EntryArrow1">
                    </div>
                </div>
                <el-input class="input1" v-model="input" :placeholder="$t('value93')" :disabled="inputJudge"></el-input>
                <div class="submitInformation" v-if="!inputJudge" @click="tokenStakeFn">{{ $t('value114') }}</div>
                <div class="TokenStaking5">{{ $t('value113') }}：{{this.tokenFish!=='--'?Math.floor(this.tokenFish*1000000000)/1000000000:'--'}}</div>
            </div>
            <div v-if="judge">
                <div class="TokenStaking4">
                    <div class="TokenStaking4_QuantityOfPledge">{{ $t('value115') }}</div>
                    <div class="TokenStaking4_RevenueInformation" @click="judge=false">
                        <div class="TokenStaking4_RevenueInformation1">{{ $t('value114') }}</div>
                        <img src="@/assets/images/EntryArrow1.png" alt="EntryArrow1" class="EntryArrow1">
                    </div>
                </div>
                <div class="LPStaking5" v-for='(item,index) in datas.getUserOrderDetailsByPageList' :key='index'>
                    <div class="LPStaking5_son">
                        <div class="LPStaking5_son1">
                            <img src="@/assets/images/UsDollarCoin.png" alt="UsDollarCoin" class="UsDollarCoin">
                            <span class="LPStaking5_token">FLOW-USDT</span>
                        </div>
                        <div class="LPStaking5_state">已赎回</div>
                    </div>
                    <div class="pageContentTens">
                        <div class="pageContentTen1">{{ $t('value116') }}</div>
                        <div class="pageContentTen2">{{item.startTime!=='0'?timestampToTime(item.startTime):datas.TheTimeBeforeCollection!=='0'?timestampToTime(datas.TheTimeBeforeCollection):'--'}}</div>
                    </div>
                    <div class="pageContentEleven">
                        <div>{{ $t('value117') }}</div>
                        <div>1123.32 FLOW</div>
                    </div>
                    <div class="pageContentEleven">
                        <div>{{ $t('value118') }}</div>
                        <div>1123.32 FLOW</div>
                    </div>
                    <div class="pageContentEleven">
                        <div>{{ $t('value99') }}</div>
                        <div>1000000.00 FLOW</div>
                    </div>
                    <div class="pageContentEleven">
                        <div>{{ $t('value57') }}</div>
                        <div>1000000.00 FLOW</div>
                    </div>
                    <div class="pageContentEleven">
                        <div>{{ $t('value58') }}</div>
                        <div>1230.32 FLOW</div>
                    </div>
                    <div class="pageContentTwelve">
                        <div>{{ $t('value119') }}</div>
                        <div>{{total}} FLOW</div>
                    </div>
                    <!-- <div class="pageContentFourteen">
                        <div class="pageContentFourteen1">{{ $t('value1120') }}</div>
                        <div class="pageContentFourteen2" @click="drawer=true">{{ $t('value103') }}</div>
                    </div> -->
                    <div class="submitInformation" v-if="!inputJudge">{{ $t('value103') }}</div>
                </div>
            </div>
            <!-- <div class="LPStaking5_son2">
                <img src="@/assets/images/record.png" alt="record" class="record">
                <span class="ThereAreNoOrdersForTheMoment">暂无订单</span>
            </div> -->
            <el-pagination
            class="elPagination"
            v-if="judge"
            small
            layout="prev, pager, next"
            :total="datas.getUserOrderLengthData"
            :page-size="pageSize"
            :current-page="currentPage"
            @current-change="handlePageChange"
            :background="true">
            </el-pagination>

        </div>
        <el-dialog
        :visible.sync="datas.dialogVisible"
        width="50%"
        :show-close="false"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        top="48vh">
        <span>{{$t('WaitForConfirmationOnTheChain')}}</span>
        </el-dialog>
    </div>
</template>

<script>
import CBNavbar from '@/components/navbar/indexTwo.vue'
import { mapState, mapGetters } from 'vuex'
import { Toast } from 'vant';
// import { MessageBox } from 'element-ui';
import './LPStaking.css'
import { datas,ztai,setMyVariable,locationHrefIndex,LPStake,LPClaim,LPWithdraw,ViewATokenBalance,isTokenAddress,approve,LPgetOrdersByPage,LPgetUserOrderLength} from "@/web3/index.js"
import Contract from 'web3-eth-contract'
import ERC20 from '../web3/ERC20.json'
export default {
    name: 'NFTPledge',
    components: {
        CBNavbar,
    },
    data() {
        return {
            input: '',
            inputJudge:false,
            judge:false,
            offTimer:null,
            Authorizationudgmentss:1,
            Authorizationudgmentsstwo:1,
            tokenFish:'--',
            total: 0,       // 总条数
            offset:1,
            datas,
            currentPage: 1,  // 当前页码
            pageSize: 1,    // 每页条数
        }
    },
    computed: {
        ...mapState(['address']),
        ...mapGetters(['isLogin']),
    },
    methods: {
        handlePageChange(page) {
            this.currentPage = page;
            // 计算 offset
            const offset = (page - 1) * this.pageSize;
            console.log('计算 offset',offset,this.pageSize,page)
            // 调用分页请求函数，传入 offset 和 limit
            LPgetOrdersByPage(this, offset, this.pageSize);
        },
      onNavbarClick(value) {
        console.log('Navbar clicked with value:', value); // 处理事件的方法，接收传递的值
        this.$router.push('/')
        // 在这里可以执行其他逻辑
      },
      upData(){
        setTimeout(async ()=>{
            console.log('打印地址')
            this.tokenFish=await ViewATokenBalance(datas.LPTokenAddress,this)
            const offset =  (this.currentPage - 1) * this.pageSize;
            LPgetOrdersByPage(this,offset,this.pageSize)
            this.total=await LPgetUserOrderLength(this)
            console.log('返回条数',this.total)
        },1500)
      },
      tokenClaimFn(){
        this.datas.dialogVisible=true
        LPClaim(this)
      },
      tokenWithdrawFn(){
        this.datas.dialogVisible=true
        LPWithdraw(1,this)
      },
      tokenStakeFn(){
        let that=this
        let ERCContract;
        ERCContract =  new Contract(ERC20, datas.LPTokenAddress); 
        console.log('过来了1');
        isTokenAddress(ERCContract,datas.LPTokenAddress,datas.LPStakingTokenAddress,this.input,this).then((res)=>{
            console.log('过来了2');
            if (res==false) {
                console.log(3);
                // 等待链上操作
                that.datas.dialogVisible=true
                approve(ERCContract,datas.LPTokenAddress,datas.LPStakingTokenAddress,this.input,that)
                this.Authorizationudgmentss=2
            }else{
                console.log('代币地址，数量',datas.LPTokenAddress,this.input);
                // 等待链上确认
                that.datas.dialogVisible=true
                LPStake(this.input,this)
                this.Authorizationudgmentsstwo=2
            }
        })
      }
    },
    watch: {
        address(newVal, oldVal) {
            if (newVal !== oldVal) {
                this.upData();
            }
        }
    },
    mounted(){
        let that=this
        this.upData()
        this.clears=setInterval(()=>{
            that.showOverlay=that.$store.state.showOverlay
            //监听交易是否完成
            ztai().then((res)=>{
                if (res) {
                    console.log(33);
                    if (that.Authorizationudgmentsstwo==2) {
                        that.Authorizationudgmentsstwo=1
                    }else if(this.Authorizationudgmentss==2){
                        this.tokenStakeFn()
                        this.Authorizationudgmentss=1
                    }
                    Toast.clear();
                    that.datas.dialogVisible=false
                    this.upData()
                    that.drawer=false
                    let txHash=''
                    setMyVariable(txHash)
                }
            })
        },1000)
        this.offTimer=setInterval(async ()=>{
            let value=await locationHrefIndex()
            if(value){
            clearInterval(this.offTimer);  
            this.offTimer=null
            }
        },1000)
    },
    //离开页面时执行函数
    beforeDestroy() {         
        clearInterval(this.clears);  
        this.clears=null
        clearInterval(this.offTimer);  
        this.offTimer=null
    },
}
</script>
<style scoped lang="less">

</style>
